"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.targetDocumentCollections = exports.previewDiffProperties = exports.Slug = void 0;
const zod_1 = require("zod");
/**
 * @todo Use a branded type
 */
exports.Slug = zod_1.z
    .string()
    .min(1)
    .regex(/^[a-z0-9-]+$/);
exports.previewDiffProperties = ["pcbLayoutNodes", "pcbLayoutRuleSets"];
/**
 * Just a utility declaration for use below in DocumentCollectionChanges.
 *
 * @remarks Note that if you add a key to this that is NOT a valid key of IDocumentData, it will blow up
 * other type declarations.
 */
exports.targetDocumentCollections = [
    "pcbLayoutNodes",
    "elements",
    "nets",
    "routes",
    "routeVertices",
    "properties",
    "pcbLayoutRuleSets",
    "assets",
    "properties",
];
//# sourceMappingURL=structure.js.map